import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-school-package',
  templateUrl: './school-package.component.html',
  styleUrls: ['./school-package.component.scss']
})
export class SchoolPackageComponent implements OnInit {
  form: FormGroup;
  productIdList: any;
  filteredList1: any;
  constructor(
    private formBuilder: FormBuilder,
    private LookupDataServiceService: LookupDataServiceService,
    private ApplicationDataService: ApplicationDataService,
    private toastr: NotificationService,


  ) { }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      ApplicationNumber: ['', Validators.required],
      ProdudctId: ['', Validators.required]

    })
    this.LookupDataServiceService.getSchoolProduct(true).subscribe((result) => {
      console.log(result);
      this.productIdList = result;
      this.filteredList1 = [...this.productIdList];
    })
  }
  onsubmit() {
    console.log(this.form.value);
    if (this.form.valid) {
      let product = this.form.value;
      this.ApplicationDataService.updateSchoolProduct(product).subscribe((result) => {
        if (result != 'Updation Failed') {
          this.toastr.showSuccess(result);
          this.form.reset()
        }
        else
          this.toastr.showError(result);
      })
    }
  }
}
